export enum CustomerTypeCdLabel {
  pickupDelivery = 'P&D',
  billTo = 'BillTo'
}
